import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import AvatarSec from "../module-common/Avatar";
import moment from "moment";
import { Scrollbars } from "react-custom-scrollbars";
import ContentBubble from "./ContentBubble";
import Ava from "../assets/avatar.png";
import {
  AgentCareStore,
  CommonStore,
  SetSessionIsNotActive,
  ResetMessageStore,
  GetHistoryHasNext,
  ResendPendingMessage
} from "../Store";
import { AgentRepliesMedia, AgentRepliesText } from "../model/Incoming";
import { observer } from "mobx-react";
import { IsChatRoomActive, LocalStorage } from "../Store";
import { Button } from "antd";
import { CustomerSendsMediaType, CustomerSendsTextType } from "../model/Outgoing";
import { LoadConversationHistory } from "../apis/LoadConversationHistory";

export default observer(
  class ContentListView extends Component {
    static propTypes = {
      messages: PropTypes.array,
      scrollRef: PropTypes.func,
      onEndReached: PropTypes.func,
      image: PropTypes.string,
    };
    static defaultProps = { messages: [] };
    scrollHeight = 0;

    async componentDidMount() {
      this.scroller.scrollToBottom();
    }

    componentWillUpdate() {
      // remember scroll height before new message arrive
      this.scrollHeight = this.scroller.getScrollHeight();
    }

    componentDidUpdate() {
      this.scroller.scrollToBottom();
    }

    render() {
      const scrollRef = this.props.scrollRef;
      const messageList = this.renderMessages();
      const pendingList = this.renderPendingMessage();
      const { hasPendingMessage, assignedAgent, historyHasNext } = CommonStore;
      const isActiveChat = IsChatRoomActive();

      console.log("History", historyHasNext);
      return (
        <Wrapper>
          {isActiveChat && (
            <AgentInfo>
              {assignedAgent
                ? `You are chatting with agent ${assignedAgent}`
                : "An agent will be here shortly"}
            </AgentInfo>
          )}
          <Scrollbars
            ref={(ref) => {
              this.scroller = ref;
              if (scrollRef) scrollRef(ref);
            }}
            onScrollFrame={this.onScrollFrame}
          >
            <ContentSec>
              {historyHasNext && (
                <Button onClick={() => LoadConversationHistory()}>Load more</Button>
              )}
              {messageList}
              {pendingList}
              {hasPendingMessage && (
                <SendingIndicator>sending..</SendingIndicator>
              )}
              {!isActiveChat && (
                <ChatIsClosed>
                  Agent has ended the chat.{" "}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      ResetMessageStore();
                      SetSessionIsNotActive();
                    }}
                  >
                    Close
                  </a>
                </ChatIsClosed>
              )}
            </ContentSec>
          </Scrollbars>
        </Wrapper>
      );
    }

    renderPendingMessage = () => {
      const { pendingList } = this.props;
      const renders = [];
      for (var key in pendingList) {
        const { payload: message, error, timestamp } = pendingList[key];
        const { _type } = message
        let element = null;
        const onErrorClick = (e) => {
          ResendPendingMessage(message)
        }
        if (_type == CustomerSendsMediaType) {
          element = (
            <WrapperBubble>
              <ContentBubble
                content={message.text}
                name={''}
                type={'media'}
                fromAgent={false}
                showTimestamp={false}
                mediaList={[{
                  uri: message.fileUri,
                  fileName: message.fileName,
                  contentType: message.contentType
                }]}
                isError={error}
                isPending={!error}
                onErrorClick={onErrorClick}
              />
            </WrapperBubble>
          )
        } else if (_type == CustomerSendsTextType) {
          element = (
            <WrapperBubble key={key}>
              <ContentBubble
                content={message.text}
                name={""}
                type={"text"}
                fromAgent={false}
                showTimestamp={false}
                isError={error}
                isPending={!error}
                onErrorClick={onErrorClick}
              />
            </WrapperBubble>
          );
        } else {

        }
        if(element) renders.push(element)
      }
      return renders
    }

    renderMessages = () => {
      const { messages } = this.props;
      messages.sort((a, b) => {
        const tsA = new Date(a.timestamp);
        const tsB = new Date(b.timestamp);
        return tsB.getTime() > tsA.getTime() ? -1 : 1;
      });
      const renders = [];
      for (var key in messages) {
        const message = messages[key];
        let fromSystem = message.isSystem;
        let element = null;
        if (fromSystem) {
          element = (
            <WrapperBubble key={key}>
              <ContentBubble
                content={message.text}
                name={"System"}
                type={"text"}
                fromAgent={true}
                showTimestamp={true}
                timestamp={new moment()}
              />
            </WrapperBubble>
          );
        } else {
          let fromAgent =
            message.type === AgentRepliesText ||
              message.type === AgentRepliesMedia
              ? true
              : false;
          let showTimestamp;
          let nextKey = parseInt(key);
          if (nextKey >= 0 && nextKey < messages.length - 1) {
            let nextMessage;
            nextMessage = messages[nextKey + 1];
            if (nextMessage.timestamp === message.timestamp) {
              showTimestamp = false;
            } else {
              showTimestamp = true;
            }
          } else {
            showTimestamp = true;
          }

          let messageType = "text";
          if (message.mediaList && message.mediaList.length > 0) {
            messageType = "media";
          }
          element = (
            <WrapperBubble key={message.messageId}>
              {fromAgent ? (
                <AvatarWrapper>
                  {AgentCareStore.displayPicture !== "" ? (
                    <AvatarSec
                      image={AgentCareStore.displayPicture}
                      isSmall={true}
                      isChat={true}
                    />
                  ) : (
                    <AvatarSec image={Ava} isSmall={true} isChat={true} />
                  )}
                </AvatarWrapper>
              ) : (
                ""
              )}

              <ContentBubble
                content={message.text}
                name={message.name}
                type={messageType}
                fromAgent={fromAgent}
                timestamp={new moment(message.timestamp)}
                showTimestamp={showTimestamp}
                mediaList={message.mediaList}
              />
            </WrapperBubble>
          );
        }
        if (element) {
          renders.push(element);
        }
      }
      return renders;
    };
    onScrollFrame = (event) => {
      // if at end of border, trigger event
      // console.log(event);
      if (event.top === 0) {
        const onEndReached = this.props.onEndReached;
        onEndReached && onEndReached();
      }
    };
  }
);

const Wrapper = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overlay-y: auto;
`;

const AgentInfo = styled.div`
  display: flex;
  color: #4d4f5c;
  font-size: 14px;
  margin: 5px;
  text-align: center;
`;

const ContentSec = styled.div`
  display: flex;
  flex-direction: column;
`;
const WrapperBubble = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  max-width: 100%;
`;
const AvatarWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-self: center;
  height: 100%;
  align-content: center;
  margin-left: 10px;
  margin-right: -10px;
`;

const SendingIndicator = styled.div`
  position: relative;
  color: #4d4f5c;
  font-size: 12px;
  margin: 5px;
  text-align: right;
`;

const ChatIsClosed = styled.div`
  position: relative;
  color: #4d4f5c;
  font-size: 14px;
  margin: 5px;
  text-align: center;
`;
